import { components as c } from "@/components";
import { useTemplateNavigationStore } from "@/features/templates/hooks/useTemplateNavigationStore";
import { useTemplateStore } from "@/features/templates/stores/useTemplateStore";
import { ContactSchema } from "@/types/zod/quickstart-settings";
import { zodResolver } from "@hookform/resolvers/zod";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";
import { useForm } from "react-hook-form";
import type { z } from "zod";
import ContactPersonComboBox from "../../../../../features/shared_attributes/components/ContactPersonComboBox";

type ContactFormData = z.infer<typeof ContactSchema>;

export const AdminForm = () => {
	const params = Route.useParams();

	const { contact_id, setContactId, organisation_id } = useTemplateStore();

	const { markStepComplete, setCurrentStep, nextStep, previousStep, steps } =
		useTemplateNavigationStore();
	const navigate = useNavigate();
	const form = useForm<ContactFormData>({
		resolver: zodResolver(ContactSchema),
		defaultValues: {
			contact_id: contact_id,
		},
	});

	useEffect(() => {
		setCurrentStep("contact");
	}, [setCurrentStep]);

	const onSubmit = (data: ContactFormData) => {
		markStepComplete("contact");
		setContactId(data.contact_id);
		nextStep();
		navigate({ to: "/new/diary/$templateId/name" });
	};

	const handlePrevious = () => {
		previousStep();

		// Find the current step index
		const currentStepIndex = steps.findIndex((step) =>
			step.key === "contact"
		);

		// Get the previous step
		if (currentStepIndex > 0) {
			const prevStep = steps[currentStepIndex - 1];
			// Navigate to the previous step's route
			if (prevStep?.route) {
				navigate({
					to: prevStep?.route.to,
					params: prevStep?.route?.params(params),
				});
			}
		}
	};

	return (
		<c.ui.Form {...form}>
			<form
				onSubmit={form.handleSubmit(onSubmit)}
				className="w-full form"
			>
				<ContactPersonComboBox organisationId={organisation_id} />
				<div className="flex justify-end gap-4 mt-8">
					<c.ui.Button
						type="button"
						variant="outline"
						onClick={handlePrevious}
					>
						Previous
					</c.ui.Button>
					<c.ui.Button type="submit">Next</c.ui.Button>
				</div>
			</form>
		</c.ui.Form>
	);
};

export const Route = createFileRoute("/_app/new/diary/$templateId/contact")({
	component: AdminForm,
});
